/**
 * Story 062 — TanStack Query keys for the component-models feature.
 */
import type { ListAssetComponentModelsExpandedParams } from "./types.js";

export const assetComponentModelsKeys = {
  all: ["asset-component-models"] as const,
  lists: () => [...assetComponentModelsKeys.all, "list"] as const,
  list: (params: ListAssetComponentModelsExpandedParams) =>
    [...assetComponentModelsKeys.lists(), params] as const,
  detail: (id: string) =>
    [...assetComponentModelsKeys.all, "detail", id] as const,
};

export const componentGroupsKeys = {
  all: ["component-groups"] as const,
  lists: () => [...componentGroupsKeys.all, "list"] as const,
  list: (assetTypeId: string | undefined) =>
    [...componentGroupsKeys.lists(), assetTypeId ?? "__all__"] as const,
};
